var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14286 0H18.8571C19.6907 0 20.4901 0.289731 21.0795 0.805456C21.6689 1.32118 22 2.02065 22 2.75V24.75C22 25.4793 21.6689 26.1788 21.0795 26.6945C20.4901 27.2103 19.6907 27.5 18.8571 27.5H3.14286C2.30932 27.5 1.50992 27.2103 0.920521 26.6945C0.331121 26.1788 0 25.4793 0 24.75V2.75C0 2.02065 0.331121 1.32118 0.920521 0.805456C1.50992 0.289731 2.30932 0 3.14286 0M3.14286 2.75V8.25H18.8571V2.75H3.14286ZM3.14286 11V13.75H6.28571V11H3.14286ZM9.42857 11V13.75H12.5714V11H9.42857ZM15.7143 11V13.75H18.8571V11H15.7143ZM3.14286 16.5V19.25H6.28571V16.5H3.14286ZM9.42857 16.5V19.25H12.5714V16.5H9.42857ZM15.7143 16.5V19.25H18.8571V16.5H15.7143ZM3.14286 22V24.75H6.28571V22H3.14286ZM9.42857 22V24.75H12.5714V22H9.42857ZM15.7143 22V24.75H18.8571V22H15.7143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCalculator);
export default __webpack_public_path__ + "static/media/white-calculator.cb09ad5cfe43269b0896b8a547543734.svg";
export { ForwardRef as ReactComponent };